import React, { Children, cloneElement } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';

class VstSubmenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      style: {},
      visible: this.props.visible,
    };

    this.calculatePosition = this.calculatePosition.bind(this);
    this.onBackButtonClick = this.onBackButtonClick.bind(this);
    this.focusAtFirstChild = this.focusAtFirstChild.bind(this);
    this.onElementClick = this.onElementClick.bind(this);
    this.calculatePosition = this.calculatePosition.bind(this);
  }

  componentDidMount() {
    this.calculatePosition();
  }

  componentWillReceiveProps(nextProps) {
    this.calculatePosition();
    if (nextProps.isMobile) {
      this.setState({ style: { display: nextProps.visible ? 'flex' : 'none' } });
    } else {
      this.setState({ style: { visibility: nextProps.visible ? 'visible' : 'hidden' } }, this.calculatePosition);
    }
    this.setState({ visible: nextProps.visible });
  }

  render() {
    const { style, isList, children } = this.props;

    return (
      <div
        className="vst-list submenu"
        style={{ ...style, ...this.state.style }}
        onFocus={this.props.openSubmenu}
        onMouseEnter={this.props.openSubmenu}
        onBlur={this.props.closeSubmenu}
        onMouseLeave={this.props.closeSubmenu}
      >
        {this.renderMobileHeader()}
        {isList ? this.renderList() : children}
      </div>
    );
  }

  onElementClick(e, onClick) {
    if (onClick) {
      onClick(e);
    }
    this.props.closeMenu();
  }

  renderList() {
    return (
      <ul ref={submenu => { this.submenu = submenu; }}>
        {Children.map(this.props.children, child => {
          if (!child.props.hidden) {
            return cloneElement(child, { onClick: (e) => this.onElementClick(e, child.props.onClick) });
          }
          return child;
        })}
        <li style={{ height: 0 }}>
          <button
            className="vst-no-button"
            onFocus={this.focusAtFirstChild}
          />
        </li>
      </ul>
    );
  }

  focusAtFirstChild() {
    if (this.submenu.firstChild.firstChild.focus) {
      this.submenu.firstChild.firstChild.focus();
    } else {
      this.submenu.firstChild.focus();
    }
  }

  onBackButtonClick(e) {
    if (this.props.onBackButtonClick) {
      this.props.onBackButtonClick();
    }
    e.stopPropagation();
  }

  renderMobileHeader() {
    if (this.props.isMobile) {
      return (
        <header className={this.props.headerClassName}>
          <div className="back-title">
            <button className="vst-no-button" onClick={this.onBackButtonClick}>
              {this.props.headerBackButton}
            </button>

            <h2 tabIndex={0}>
              {this.props.headerTitle}
            </h2>
          </div>

          <button
            className="vst-no-button"
            onClick={this.onApplyClick}
          >
            {this.props.headerApplyButton}
          </button>
        </header>
      );
    }
    return null;
  }

  getWinSize() {
    const body = document.body;
    const elem = document.documentElement;
    return {
      innerWidth: window.innerWidth || Math.max(elem.clientWidth, body.clientWidth),
      innerHeight: window.innerHeight || Math.max(elem.clientHeight, body.clientHeight),
      scrollY: window.scrollY || elem.scrollTop || body.scrollTop || 0,
      scrollX: window.scrollX || elem.scrollLeft || body.scrollLeft || 0,
    };
  }

  calculatePosition() {
    if (this.props.isMobile) {
      return;
    }
    const submenuNode = findDOMNode(this);
    const targetNode = findDOMNode(submenuNode.parentNode);
    const menuNode = findDOMNode(targetNode.parentNode);
    const menu = menuNode.getBoundingClientRect();
    const target = targetNode.getBoundingClientRect();
    const submenu = submenuNode.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;

    const style = this.state.style;

    // Overflows bottom
    // const offset = target.top - menu.top;
    if (target.top + submenu.height > windowHeight) {
      style.bottom = target.top - windowHeight + 50;
    } else {
      style.top = 0;
    }

    // Overflows right
    const overflowsRight = menu.left + menu.width + submenu.width > windowWidth;
    const overflowsLeft = menu.left < submenu.width;

    if (overflowsRight && overflowsLeft) {
      style.right = 'unset';
      style.left = windowWidth - menu.width - menu.left - 5;
    } else if (overflowsRight) {
      style.left = 'unset';
      style.right = menu.width;
    } else if (overflowsLeft) {
      style.right = 'unset';
      style.left = menu.width;
    }

    this.setState({ style });
  }
}

VstSubmenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  closeMenu: PropTypes.func,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
  style: PropTypes.object,
  onBackButtonClick: PropTypes.func,
  closeSubmenu: PropTypes.func.isRequired,
  openSubmenu: PropTypes.func.isRequired,
  headerBackButton: PropTypes.node,
  headerTitle: PropTypes.node,
  headerClassName: PropTypes.node,
  headerApplyButton: PropTypes.node,
  isMobile: PropTypes.bool,
  visible: PropTypes.bool,
  isList: PropTypes.bool,
};

VstSubmenuItem.defaultProps = {
  headerTitle: 'Submenu Title',
  headerBackButton: 'Back',
  style: {},
  isList: true
};

export default VstSubmenuItem;
